import {Flex} from '@chakra-ui/react'
import Exam from '@pages/ExamPage/components/Exam'

const PracticeExam = ({data, type}: any) => {
  return (
    <Flex flexDirection={'column'} gap={{base: '16px', md: '32px'}}>
      {data?.topic_by_sets?.map((value: any, index: number) => {
        return <Exam key={index} data={value} index={index} type={type} />
      })}
    </Flex>
  )
}

export default PracticeExam
